export const keyMap = {
  HASH_RATE: 'hashRate',
  REJECT_RATE: 'rejectRate',
};
